import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs font-medium text-accent-400 mb-3">
            <i className="ri-flashlight-line"></i>
            实时动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新快讯</h2>
          <p className="mt-2 text-sm text-foreground-500">第一时间掌握平台最新影视资源动态</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300/50 -translate-x-1/2 hidden md:block"></div>

          <div className="flex flex-col gap-6">
            {updatesData.map((item, idx) => (
              <div
                key={item.id}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                  idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="hidden md:flex absolute left-1/2 top-6 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 -translate-x-1/2 z-10"></div>

                <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <div className="md:hidden pl-8 relative">
                    <div className="absolute left-0 top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-50 z-10"></div>
                    <span className="text-xs font-medium text-foreground-400">{item.date}</span>
                  </div>
                  <span className="hidden md:inline text-xs font-medium text-foreground-400">{item.date}</span>
                </div>

                <div className={`flex-1 ${idx % 2 === 0 ? 'md:pl-12' : 'md:pr-12'}`}>
                  <div className="md:hidden pl-8 relative">
                    <div className="p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300">
                      <div className="flex items-center gap-2 mb-2">
                        <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap ${
                          item.accent
                            ? 'bg-accent-500/15 text-accent-400'
                            : 'bg-primary-500/10 text-primary-400'
                        }`}>
                          {item.tag}
                        </span>
                      </div>
                      <h3 className="text-sm font-medium text-foreground-800 leading-relaxed">{item.title}</h3>
                    </div>
                  </div>
                  <div className="hidden md:block p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300">
                    <div className="flex items-center gap-2 mb-2">
                      <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap ${
                        item.accent
                          ? 'bg-accent-500/15 text-accent-400'
                          : 'bg-primary-500/10 text-primary-400'
                      }`}>
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-800 leading-relaxed">{item.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}